"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import * as ToastPrimitives from "@radix-ui/react-toast";

function ToastProvider({
  ...props
}: React.ComponentProps<typeof ToastPrimitives.Provider>) {
  return <ToastPrimitives.Provider data-slot="toast-provider" {...props} />;
}

function ToastViewport({
  className,
  ...props
}: React.ComponentProps<typeof ToastPrimitives.Viewport>) {
  return (
    <ToastPrimitives.Viewport
      data-slot="toast-viewport"
      className={cn(
        "top-24 md:top-4 right-4 z-100 fixed flex flex-col gap-2 outline-hidden w-full max-w-sm max-h-screen",
        className,
      )}
      {...props}
    />
  );
}

function Toast({
  className,
  ...props
}: React.ComponentProps<typeof ToastPrimitives.Root>) {
  return (
    <ToastPrimitives.Root
      data-slot="toast"
      className={cn(
        "group relative flex items-center gap-3 bg-gray-100 shadow-lg p-4 border rounded-md w-full overflow-hidden pointer-events-auto",
        className,
      )}
      {...props}
    />
  );
}

function ToastDescription({
  className,
  ...props
}: React.ComponentProps<typeof ToastPrimitives.Description>) {
  return (
    <ToastPrimitives.Description
      data-slot="toast-description"
      className={cn("font-normal text-sm", className)}
      {...props}
    />
  );
}

function ToastClose({
  className,
  ...props
}: React.ComponentProps<typeof ToastPrimitives.Close>) {
  return (
    <ToastPrimitives.Close
      data-slot="toast-close"
      className={cn(
        "top-2 right-2 absolute p-1 rounded-sm text-muted-foreground hover:text-foreground",
        className,
      )}
      toast-close=""
      {...props}
    />
  );
}

export { Toast, ToastClose, ToastDescription, ToastProvider, ToastViewport };
